<script setup lang="ts">
import type { Faq } from '@/types/calculator'

/** Visible FAQ section — question/answer pairs are shown, not collapsed, for SEO. */
defineProps<{
  faqs: Faq[]
}>()
</script>

<template>
  <section class="faq" aria-labelledby="faq-title">
    <h2 id="faq-title">Frequently asked questions</h2>
    <div v-for="faq in faqs" :key="faq.question" class="faq__item">
      <h3 class="faq__question">{{ faq.question }}</h3>
      <p class="faq__answer">{{ faq.answer }}</p>
    </div>
  </section>
</template>

<style scoped>
.faq__item {
  margin-top: var(--space-5);
}

.faq__question {
  font-size: var(--text-base);
  font-weight: var(--font-semibold);
  color: var(--color-text);
  margin: 0;
}

.faq__answer {
  margin-top: var(--space-2);
  margin-bottom: 0;
}
</style>
